import { CurrenciesService } from "booking_app/services/currencies.service";
import { GlobalStateService } from "booking_app/services/global-state.service";
import { Bindings } from "booking_app/types";

declare var angular: any;

export class BookingPriceBreakdownController {
  static $inject = ["$filter", "$rootScope", "CurrenciesService", "GlobalStateService"];

  data: any;

  constructor(
    private $filter: any,
    private $rootScope: any,
    private currenciesService: CurrenciesService,
    private globalStateService: GlobalStateService,
  ) {}

  $onInit(): void {
    if (this.data) {
      this.calculatePriceBreakdown(this.data.price_breakdown_metadata);
    }
  }

  hasPriceBreakdown() {
    return this.data.price_breakdown_metadata?.included_taxes_and_fees?.length > 0;
  }

  hasAdditionalCharge() {
    return this.data.price_breakdown_metadata?.excluded_taxes_and_fees_total_in_currency > 0;
  }

  private calculatePriceBreakdown(data: any): void {
    const originalTotalCharge = this.adjustPriceBreakdown(
      data.base_rate_in_currency + data.included_taxes_and_fees_total_in_currency,
    );
    data.total_taxes_and_fees = this.adjustPriceBreakdown(data.included_taxes_and_fees_total_in_currency);
    data.taxes_and_fees = data.included_taxes_and_fees_in_currency.map((taxAndFeeItem) => (
      {id: taxAndFeeItem.id, amount: this.adjustPriceBreakdown(taxAndFeeItem.amount)}
    ));
    data.price_of_stay = originalTotalCharge - data.total_taxes_and_fees;
  }

  // apply cash payment tier to price components
  private adjustPriceBreakdown(baseCash: number): number {
    // gets last payment tier to multiply and converts to usd
    const travelType: string = this.globalStateService.travelType;
    const adjustment: number = this.$rootScope.pointsPartner.cashPaymentTiersBy(travelType).at(-1);

    // if there's no saved adjustment, we return the pre-adjusted base value
    const adjustedValue = baseCash * (adjustment === 0 ? 1 : adjustment);
    return parseFloat(this.currenciesService.adjustDecimals(adjustedValue, 2));
  }

  public formatValue(value): string {
    if (this.$rootScope.selectedCurrency.decimalPlace === 0) {
      return this.$filter("numberFmt")(Math.ceil(value), this.$rootScope.selectedLocale, 0);
    }
    return this.$filter("numberFmt")(value, this.$rootScope.selectedLocale, 2);
  }
}

angular.module("BookingApp").component("bookingPriceBreakdown", {
  bindings: {
    data: Bindings.ONE_WAY,
  },
  controller: BookingPriceBreakdownController,
  template: `
    <div class="booking-price-breakdown-container" ng-if="$ctrl.data">
      <h5 ng-if="$ctrl.hasPriceBreakdown()" class="booking-price-breakdown-title">{{ "checkout.tax_breakdown.label.price_summary" | translate }}</h5>
      <div ng-if="$ctrl.hasPriceBreakdown()" class="price-list">
        <div class="price-item">
          <div class="label booking-price-breakdown-label">
            <span>{{ "checkout.tax_breakdown.label.price_of_stay" | translate }}</span>
            <div class="booking-info-text">
              <span class="lowercase" ng-if="$ctrl.data.numOfRooms == 1">{{ "Single Room Count" | translate }}</span>
              <span class="lowercase" ng-if="$ctrl.data.numOfRooms > 1">{{ "Multiple Room Count" | translate: { count: $ctrl.data.numOfRooms } }}</span>
              <span>,&nbsp; </span>
              <span class="lowercase" ng-if="$ctrl.data.number_of_nights == 1">{{ "Single Night Count" | translate: { count: 1 } }}</span>
              <span class="lowercase" ng-if="$ctrl.data.number_of_nights > 1">{{ "Multiple Nights Count" | translate: { count: $ctrl.data.number_of_nights } }}</span>
            </div>
          </div>
          <div class="value booking-price-breakdown-value">
            <span>
              {{ $ctrl.data.currency | codeSymbolFmt }}{{ $ctrl.formatValue($ctrl.data.price_breakdown_metadata.price_of_stay) }}
            </span>
          </div>
        </div>
        <div class="price-item" ng-repeat="taxAndFeeItem in $ctrl.data.price_breakdown_metadata.taxes_and_fees">
          <div class="label booking-price-breakdown-label">
            <span translate="checkout.tax_breakdown.label.{{ taxAndFeeItem.id }}">
            </span>
          </div>
          <div class="value booking-price-breakdown-value">
            <span class="currency">
              {{ $ctrl.data.currency | codeSymbolFmt }}{{ $ctrl.formatValue(taxAndFeeItem.amount) }}
            </span>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.hasAdditionalCharge()">
        <booking-additional-charge-notice data="$ctrl.data" />
      </div>
      <hr ng-if="$ctrl.hasAdditionalCharge() || $ctrl.hasPriceBreakdown()"/>
    </div>
  `
});
